import { type OrderbookRowItem } from "~/features/orderbook/models/orderbookModels";

const sortByDate =
  (getDate: (row: OrderbookRowItem) => Date | undefined | null) =>
  (a: OrderbookRowItem, b: OrderbookRowItem) => {
    const dateA = getDate(a)?.getTime();
    const dateB = getDate(b)?.getTime();

    if (dateA == null && dateB == null) {
      return 0;
    }
    if (dateA == null) {
      return 1;
    }
    if (dateB == null) {
      return -1;
    }

    return dateA - dateB;
  };

export const sortConfirmedDeliveryDate = sortByDate(
  (row) => row.curDeliveryDate,
);

export const sortRequestedDeliveryDate = sortByDate(
  (row) => row.requestedDeliveryDate,
);

export const sortAccount = (a: OrderbookRowItem, b: OrderbookRowItem) => {
  let result = a.account?.name?.localeCompare(b.account?.name ?? "");
  if (!result) {
    result = a.account?.endCustomerName?.localeCompare(
      b.account?.endCustomerName ?? "",
    );
  }
  return result ?? 0;
};
